<div class="outer-div">
    <mat-drawer-container class="drawer-container">

        <div class="mat-drawer-content-div">

            <!-- Define the component's action bar (similar to what is used in the form builder). -->
            <div class="action-bar">
                <h1 class="component-title">{{this.Title}}</h1>

                <!-- Need to use a <div/> to always show the tooltip (won't work on a disabled button). '-->
                <!--
                <div matTooltip="{{this.DrawChartButtonTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                    <button mat-flat-button
                            disabled="{{this.SelectionMissing}}"
                            class="action-item theme-primary-btn"
                            color="primary"
                            (click)="this.drawChart()">
                        <mat-icon class="draw-chart-mat-icon"
                                  aria-hidden="false"
                                  aria-label="Generate report">stacked_bar_chart</mat-icon>
                    </button>
                </div>
                -->    
            </div>

            <!-- Define the <div/> that contains most of the component's content. -->
            <div class="horizontal-flexbox-div"
                 id="horizontal-flexbox-div">
                <!-- Use a configuration component. -->
                <div class="config-div">
                    <app-response-management-config class="config-component"
                                                    [reportTypes]="this.ReportTypes"
                                                    [chartTypes]="this.ChartTypes"
                                                    (getSiteWorkflows)="this.getSiteWorkflows($event)"
                                                    (getMagicFolders)="this.getMagicFolders($event)"
                                                    (getMagicFormInstances)="this.getMagicFormInstances($event)"
                                                    (reportTypeSelectionChanged)="this.reportTypeSelectionChanged($event)"
                                                    (chartTypeSelectionChanged)="this.chartTypeSelectionChanged($event)"
                                                    (workflowSelectionChanged)="this.workflowSelectionChanged($event)"
                                                    (magicFolderSelectionChanged)="this.magicFolderSelectionChanged($event)"
                                                    (magicFormInstanceSelectionChanged)="this.magicFormInstanceSelectionChanged($event)"></app-response-management-config>
                </div>


                <!-- Show/draw a chart when we have eChart options/data. -->
                <ng-container *ngIf="this.EChartsOptions != null">
                    <div echarts
                         [options]="this.EChartsOptions"
                         class="echarts-div"></div>
                </ng-container>
            </div>
        </div>

        <!--
        <mat-drawer #permissionsDrawer
                    mode="over"
                    position="end"
                    class="permissions-drawer">
        </mat-drawer>
            -->
    </mat-drawer-container>
</div>
